export enum Language {
    en = 'en',
    ar = 'ar',
}
